<template>
  <section>
    <b-dropdown
      aria-role="list"
      class="local-lm-filters"
      v-model="selectedOption"
      :disabled="flag"
      @active-change="stateOption"
    >
      <button
        class="button"
        type="button"
        slot="trigger"
      >
        <div class="local-lm-filters--placeholder">
          <template>
            <span
              v-if="!selectedOption"
              v-t="$t('OrderStatesFilter.title')"
            />
            <span
              v-if="selectedOption"
            >
              {{ $t(`Orders.${selectedOption}`) | upperCase }}
            </span>
          </template>
          <b-icon
            icon="chevron-down"
          />
        </div>
      </button>
      <b-dropdown-item
        v-for="(state, id) in states"
        :key="id"
        :value="state"
      >
        {{ $t(`Orders.${state}`) | upperCase }}
      </b-dropdown-item>
    </b-dropdown>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OrderStatesFilter',
  computed: {
    ...mapGetters('filters', [
      'states'
    ]),
    flag () {
      return this.$attrs.hasOpenFilterOrderStates
    }
  },
  mounted () {
    this.$store.dispatch('filters/getOrderStates')
    this.$eventBus.$on('cleanFilters', () => {
      this.selectedOption = null
    })
  },
  data () {
    return {
      selectedOption: null
    }
  },
  methods: {
    stateOption () {
      const flag = !!(this.selectedOption) || false
      this.$store.dispatch('filters/setOrderState', this.selectedOption)
      this.$eventBus.$emit('orderStatesWrite', flag)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/OrderStatesFilter.vue